import { render, staticRenderFns } from "./contactHome.vue?vue&type=template&id=9a24c73a&"
import script from "./contactHome.vue?vue&type=script&lang=js&"
export * from "./contactHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports